import { Helmet } from 'react-helmet-async';

export function SEO({ 
  title = 'Jadoby Hôtel - Excellence de l\'hospitalité à Kinshasa',
  description = 'Découvrez le luxe et le confort au cœur de Kinshasa. Chambres élégantes, service personnalisé et expérience inoubliable vous attendent à l\'Hôtel Jadoby.',
  image = 'https://images.unsplash.com/photo-1566073771259-6a8506099945?auto=format&fit=crop&q=80',
  url = 'https://jadoby-hotel.com'
}) {
  return (
    <Helmet>
      <html lang="fr" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      
      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      
      {/* Autres métadonnées importantes */}
      <link rel="canonical" href={url} />
      <meta name="theme-color" content="#ef2543" />
    </Helmet>
  );
}